export const quantityTypes = [
    { value: "bag", label: "Bag" },
    { value: "bale", label: "Bale" },
    { value: "barrel", label: "Barrel" },
    { value: "box", label: "Box" },
    { value: "bundle", label: "Bundle" },
    { value: "can", label: "Can" },
    { value: "carton", label: "Carton" },
    { value: "cm", label: "Centimeter (Cm)" },
    { value: "ft", label: "Feet (Ft)" },
    { value: "g", label: "Gram (Gms)" },
    { value: "in", label: "Inch (In)" },
    { value: "kg", label: "Kilogram (KG)" },
    { value: "l", label: "Liter (L)" },
    { value: "m", label: "Meter (M)" },
    { value: "mt", label: "Metric Ton (MT)" },
    { value: "pack", label: "Pack" },
    { value: "pallet", label: "Pallet" },
    { value: "piece", label: "Piece" },
    { value: "roll", label: "Roll" },
    { value: "set", label: "Set" },
    { value: "strip", label: "Strip" },
    { value: "tube", label: "Tube" },
    { value: "yd", label: "Yard (yd)" },
    { value: "qtl", label: "Quintal" },
  ];